export default "__VITE_ASSET__B369n7Lj__"